import type { SalesforceConnectRequestPayload } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useSalesforceConnect(
  options?: UseMutationOptions<void, unknown, SalesforceConnectRequestPayload>,
) {
  return useMutation((salesforceConnectRequest) => {
    const api = getPrivateApi();

    return api.salesforceConnect({ salesforceConnectRequest });
  }, options);
}
